import { Injectable } from '@angular/core';
import { IPersonaRegistroEntity, IUsuarioRegistro } from '../models/usuario-registro-interface'
import { DataService } from './data-service';
import { IDireccionKeycloak, mappearDireccionJSON } from '../models/direccion-estructurada';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserUtilsService {
  codigosVital: any;
  municipiosData: any;
  keycloack_URL_userId = environment.URL_KEYCLOAK + environment.USER_KEYCLOAK_ENDPOINT;
  listaPaises: any;

  constructor(private dataService: DataService,
    private http: HttpClient) { }


  async transformarUsuario(usuarioKeycloak: any, usuarioVital): Promise<IUsuarioRegistro> {
    let usuarioRegistro: IUsuarioRegistro;
    usuarioVital = usuarioVital[0];
    if (!usuarioKeycloak.attributes && usuarioVital) {
      usuarioRegistro = {
        email: usuarioKeycloak.email ? usuarioKeycloak.email : usuarioVital.correo_electronico,
        attributes: {
          tipoIdentificacion: [this.encontrarTipoId(usuarioVital.tipo_identificación)],
          numeroIdentificacion: [usuarioVital.numero_identificacion],
          fechaExpedicion: [usuarioVital.fecha_expedicion_documento],
          fecha_vencimiento: [usuarioVital.fecha_vencimiento_documento],
          primerNombre: [usuarioVital.primer_nombre],
          segundoNombre: [usuarioVital.segundo_nombre],
          primerApellido: [usuarioVital.primer_apellido],
          segundoApellido: [usuarioVital.segundo_apellido],
          mismaInformacionResidencia: [usuarioVital.misma_info_residencia],
          DireccionJSON: null,
          DireccionResidenciaJSON: null,
          LOA: ['loa:1'],

        }
      }
    } else {

      const att = usuarioKeycloak.attributes;

      const direccionRecibida = att.DireccionJSON && att.DireccionJSON[0] ? att.DireccionJSON : att.DireccionResidenciaJSON;
      const DireccionMappeada: IDireccionKeycloak = mappearDireccionJSON(direccionRecibida);
      //let DireccionMappeada: IDireccionKeycloak = JSON.parse("{\"pais\":\"CO\",\"departamento\":\"\",\"codeDepartamento\":\"50\",\"municipio\":\"\",\"codeMunicipio\":\"50001\",\"tipoViaPrincipal\":\"CL\",\"identificacionPrincipal\":\"17\",\"letra\":\"A\",\"bis\":\"\",\"cuadrante\":null,\"viaGeneradora\":\"15\",\"letraViaGeneradora\":null,\"numero\":\"41\",\"cuadranteNumero\":null,\"tipoComplemento\":\"\",\"complemento\":\"\",\"direccionRural\":\"\",\"direccionInternacional\":\"\",\"zonaRural\":0,\"bis2\":\"\"}");
      const fechaExpedicionFormateada = this.formatearFecha(att.fechaExpedicion[0]);
      const fechaVencimientoFormateada = this.formatearFecha(att.fechaVencimiento[0]);
      const telefonoFormateado = await this.validarFormatoTelefono(att.numeroTelefono, att.Telefono_code) || '';
      let telefonoComercialFormateado = '';
      if (att.TelefonoComercial.length > 0) {
        telefonoComercialFormateado = await this.validarFormatoTelefono(att.TelefonoComercial, att.Telefono_code);
      }

      const tipoPersonausuario = this.calcularTipoPersona(att.tipoPersona, att.NitEmpresa);
      const mismaInfoResidencia = this.calcularMismaInformacionResidencia(tipoPersonausuario, att, "mismaInformacionResidencia");
      const mismaInfoResidenciaEmpresa = this.calcularMismaInformacionResidencia(tipoPersonausuario, att, "mismaInformacionResidenciaEmpresa");

      let DireccionCorrespondenciaAuxJson = mismaInfoResidencia? DireccionMappeada : att.DireccionCorrespondenciaJSON;
      let DireccionCorrespondenciaEmpresaAuxJson = mismaInfoResidenciaEmpresa? att.DireccionResidenciaEmpresaJSON : att.DireccionCorrespondenciaJSONEmpresa;

      usuarioRegistro = {
        email: usuarioKeycloak.email ? usuarioKeycloak.email : usuarioVital.correo_electronico,
        attributes: {
          CorreoElectronicoComercial: att.CorreoElectronicoComercial,
          CorreoElectronicoRepresentante: att.CorreoElectronicoRepresentante ? [0] ?? att.CorreoElectronicoRepresentante[0] : [usuarioKeycloak.email],
          DIV: att.DIV,
          Direccion: att.Direccion,
          DireccionComercial: att.DireccionComercial,
          DireccionCorrespondencia: att.DireccionCorrespondencia,
          DireccionCorrespondenciaEmpresa: att.DireccionCorrespondenciaEmpresa || [""],
          DireccionCorrespondenciaEmpresaJSON: att.DireccionCorrespondenciaEmpresaJSON || [""],
          DireccionCorrespondenciaJSON: DireccionCorrespondenciaAuxJson,
          DireccionCorrespondenciaJSONEmpresa: DireccionCorrespondenciaEmpresaAuxJson,
          DireccionJSON: DireccionMappeada,
          DireccionResidencia: att.DireccionResidencia[0] || att.DireccionResidencia[0] !== "" ? att.DireccionResidencia : "Colombia",
          DireccionResidenciaEmpresa: att.DireccionResidenciaEmpresa,
          DireccionResidenciaEmpresaJSON: att.DireccionResidenciaEmpresaJSON,
          DireccionResidenciaJSON: [JSON.stringify(DireccionMappeada)],
          LOA: att.LOA,
          NitEmpresa: att.NitEmpresa,
          NombreRepresentanteLegal: att.NombreRepresentanteLegal,
          NumeroIdentificacionRepresentanteLegal: att.NumeroIdentificacionRepresentanteLegal,
          RazonSocialEmpresa: att.RazonSocialEmpresa,
          TelefonoComercial: [telefonoComercialFormateado],
          fechaExpedicion: fechaExpedicionFormateada,
          fechaVencimiento: fechaVencimientoFormateada,
          longitudDireccion: att.longitudDireccion,
          mismaInformacionResidencia: mismaInfoResidencia,
          mismaInformacionResidenciaEmpresa: mismaInfoResidenciaEmpresa,
          mismaInformacionResidenciaRepresentante: att.mismaInformacionResidenciaRepresentante,
          numeroIdentificacion: att.numeroIdentificacion,
          numeroTelefono: [telefonoFormateado],
          primerApellido: att.primerApellido,
          primerNombre: att.primerNombre,
          segundoApellido: att.segundoApellido,
          segundoNombre: att.segundoNombre,
          tipoIdentificacion: att.tipoIdentificacion,
          tipoPersona: tipoPersonausuario,
        }
      };
    }
    return usuarioRegistro;
  }


  calcularTipoPersona(tipoPersona: any, nitEmpresa: any): string[] {
    if (tipoPersona && tipoPersona[0]) {
      return tipoPersona;
    }

    if (nitEmpresa && nitEmpresa[0]) {
      return ["juridica"];
    }

    return ["natural"];
  }

  calcularMismaInformacionResidencia(
    tipoPersona: string[],
    attributesObj: { [key: string]: string[] | undefined },
    key: string
  ): string[] {
    // Check for the specified key in the attributes object
    const attributeValue = attributesObj[key];
    if (attributeValue && attributeValue[0] !== "") {
      return attributeValue;
    }

    // Handle cases based on "tipoPersona"
    if (tipoPersona[0] === "natural") {
      return [];
    }

    // Default return for non-natural persona
    return ['false'];
  }


  validarFormatoTelefono(telefono: string[], codigo: string[]): string {
    if (!telefono || telefono.length === 0)
      return "";

    if (telefono && telefono[0].toString().includes("(+")) {
      return telefono[0];
    }

    const telefonoFormateado = new Promise<string>((resolve, reject) => {
      this.encontrarCodigoPais(codigo[0])
        .then(codigoPais => {
          resolve(`(+${codigoPais}) ${codigo[0]}`);
        })
        .catch(error => reject(error));
    }).then(result => result);

    telefonoFormateado.then(formattedPhone => {
      console.log(formattedPhone);
      return formattedPhone;
    }).catch(error => {
      console.error('Error formatting phone number:', error);
    });
    return `(+57) ${telefono[0]}`
  }

  async encontrarCodigoPais(codigoString: any): Promise<string> {
    if (!this.listaPaises) {
      this.listaPaises = await firstValueFrom(this.dataService.getPaisesData());
    }
    if (Array.isArray(this.listaPaises)) {
      for (const pais of this.listaPaises) {
        if (pais.iso2 === codigoString.toUpperCase()) {
          return pais.phoneCode;
        }
      }
    }
    return "57";
  }

  formatearFecha(fechaInput: string) {
    //fechaInput is = "dd/mm/yyyy" example "30/11/2000" we trasform to "yyyy-mm-dd" format for example "2000-11-30"
    if (fechaInput && fechaInput !== null) {
      let fechaArray = fechaInput.split("/");
      return [fechaArray[2] + "-" + fechaArray[1] + "-" + fechaArray[0]];
    }
    return null;
  }



  async transformaUsrVital(usuarioKeyCloak: IUsuarioRegistro): Promise<IPersonaRegistroEntity | null> {
    try {
      await this.dataService.getCodigosVital().toPromise().then(data => {
        this.codigosVital = data;
      });
      var tipoDocumentoAux;
      var NumeroDocumento;
      const codDepartamento = usuarioKeyCloak.attributes.DireccionJSON.departamento || "11";
      const codMunicipio = usuarioKeyCloak.attributes.DireccionJSON.municipio || "11001";
      const PaisContacto = this.buscarID("PaisContacto", "Colombia");
      const direccion = this.getValidAddress(usuarioKeyCloak.attributes);
      const direccionFormateada = this.reemplazoCarateresEspeciales(direccion);

      if (usuarioKeyCloak.attributes?.NitEmpresa && usuarioKeyCloak.attributes?.NitEmpresa[0] !== "") {
        // cuando el objeto tre el NIT asumimos que la persona autenticada es un representante de una empresa
        tipoDocumentoAux = "2";
        NumeroDocumento = usuarioKeyCloak.attributes?.NitEmpresa;
      } else {
        // si el nit no esta dispinible en el objeto se asume que es una persona natural
        tipoDocumentoAux = this.buscarID("TipoDocumento", usuarioKeyCloak.attributes?.tipoIdentificacion[0].toUpperCase());
        NumeroDocumento = usuarioKeyCloak.attributes?.numeroIdentificacion;
      }

      const PersonaRegistroEntity: IPersonaRegistroEntity = {
        AutoridadAmbientalID: this.buscarID("AutoridadAmbientalID", "Minambiente"),
        AutorizaEnvioNotificaciones: true,
        Celular: this.validateField(usuarioKeyCloak.attributes?.TelefonoComercial) || "",
        CorreoElectronico: usuarioKeyCloak.email || "",
        DepartamentoContactoID: codDepartamento,
        DepartamentoCorrespondenciaID: codDepartamento,
        DepartamentoOrigenDocumentoID: '-1',
        DireccionContacto: direccionFormateada ? direccionFormateada : "calle falsa 123",
        DireccionCorrespondencia: direccionFormateada ? direccionFormateada : "calle falsa 123",
        Fax: this.validateField(usuarioKeyCloak.attributes?.numeroTelefono) || "",
        MunicipioContactoID: codMunicipio,
        MunicipioCorrespondenciaID: codMunicipio,
        MunicipioOrigenDocumentoID: '-1',
        NumeroDocumento: this.validateField(NumeroDocumento) || "",
        PaisContactoID: PaisContacto,
        PaisCorrespondenciaID: PaisContacto,
        PersonaVITALID: '-1',
        PrimerApellido: this.validateField(usuarioKeyCloak.attributes?.primerApellido) || "",
        PrimerNombre: this.validateField(usuarioKeyCloak.attributes?.primerNombre) || "",
        RazonSocial: this.validateField(usuarioKeyCloak.attributes?.RazonSocialEmpresa) || "",
        SegundoApellido: this.validateField(usuarioKeyCloak.attributes?.segundoApellido) || "",
        SegundoNombre: this.validateField(usuarioKeyCloak.attributes?.segundoNombre) || "",
        Telefono: this.validateField(usuarioKeyCloak.attributes?.numeroTelefono) || "",
        TipoDocumentoID: tipoDocumentoAux,
        TipoPersonaID: this.buscarID("TipoPersona", usuarioKeyCloak.attributes?.tipoPersona[0]),
      };
      return PersonaRegistroEntity;
    } catch (error) {
      console.error("Error transforming user data:", error);
      throw error;
    }
  }

  private isValidAddress(address: string | undefined): boolean {
    return address !== undefined && address !== null && address.trim() !== '';
  }

  private getValidAddress(attributes: any): string {
    const addressFields = [
      'Direccion',
      'DireccionResidencia',
      'DireccionCorrespondencia',
      'DireccionComercial'
    ];

    for (const field of addressFields) {
      const address = attributes[field]?.[0];
      if (this.isValidAddress(address)) {
        return address;
      }
    }

    return '';
  }

  validateField(value: any): string {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    return value[0];
  }

  encontrarTipoId(tipoID: string): string {
    let resultado: string = "";
    tipoID = tipoID.trim().toLowerCase();
    switch (tipoID) {
      case "cédula":
        resultado = "cc"
        break;

      default:
        break;
    }
    return resultado;
  }

  buscarID(nombreObjeto: string, nombreValor: string): string | null {
    const objeto = this.codigosVital[nombreObjeto];
    for (const item of objeto) {
      for (const key in item) {
        if (item[key] === nombreValor) {
          return key;
        }
      }
    }
    return null;
  }

  // Function to find municipio ID based on depID and name
  findMunicipioID(depID, name) {
    const depIDStr = depID.toString();

    for (const dep of this.municipiosData.municipios) {
      if (dep.hasOwnProperty(depIDStr)) {
        for (const municipio of dep[depIDStr]) {
          // Find the municipio with the matching name
          for (const [id, municipioName] of Object.entries(municipio)) {
            if (municipioName === name) {
              return id;
            }
          }
        }
      }
    }

    return null;
  }

  invocarServicioKeycloak(subUsuario: string, keyCloaclTkn): Observable<any> {
    const url = `${this.keycloack_URL_userId}/${subUsuario}`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${keyCloaclTkn}`
    });
    return this.http.get(url, { headers });
  }

  reemplazoCarateresEspeciales(direccion: any): string {
    let direccionAuxiliar = Array.isArray(direccion) ? direccion.join(', ') : direccion || "";
    direccionAuxiliar = direccionAuxiliar
      .replaceAll("#", "No").replaceAll("-", "")
      .replace(/[\r\n]+/g, " ") // remover saltos de linea
      .replaceAll("ñ", "n").replaceAll("Ñ", "N")
      .replaceAll("á", "a").replaceAll("Á", "A")
      .replaceAll("é", "e").replaceAll("É", "E")
      .replaceAll("í", "i").replaceAll("Í", "I")
      .replaceAll("ó", "o").replaceAll("Ó", "O")
      .replaceAll("ú", "u").replaceAll("Ú", "U")
      .replaceAll(",", "").replaceAll(".", "")
      .trim();
    return direccionAuxiliar;
  }

}



